import {
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@material-ui/core";
import jwt_decode from "jwt-decode";
import { useEffect, useRef, useState } from "react";
import LinesEllipsis from "react-lines-ellipsis";
import useCopyClipboard from "react-use-clipboard";
import { Keyboard, Videocam } from "@material-ui/icons";
import { toast } from "material-react-toastify";

import useWindowSize from "../../../utils/useWindowSize";
import { CopyIcon } from "../../../icons";
import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import useResponsiveSize from "../../../utils/useResponsiveSize";
import axios from "axios";

export default function MeetingDetailModal({
  internalPadding,
  name,
  setName,
  nameErr,
  setNameErr,
  startMeeting,
  meetingTitle,
  meetingUrl,
  type,
  onCreateMeeting,
}) {
  const [selectedDate, handleDateChange] = useState(new Date());

  const theme = useTheme();
  const [descriptionBoxHeight, setDescriptionBoxHeight] = useState(0);
  const [copyBoxHeight, setCopyBoxHeight] = useState(0);

  const token = localStorage.getItem("signinToken");
  let user;
  if (token) {
    var decodedHeader = jwt_decode(localStorage.getItem("signinToken"));
    user = decodedHeader?.user;
  }

  const [copied, setCopied] = useCopyClipboard(
    `${user?.name} have invited you to meeting \n  Link:${meetingUrl}`,
    {
      successDuration: 4000,
    }
  );

  const descriptionBoxRef = useRef();
  const copyBoxRef = useRef();

  const handleValidation = () => {
    let isValid = true;
    if (name.length < 3) {
      isValid = false;
      setNameErr(true);
      return false;
    } else {
      setNameErr(false);
    }
    return isValid;
  };

  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    if (
      descriptionBoxRef.current &&
      descriptionBoxRef.current.offsetHeight !== descriptionBoxHeight
    ) {
      setDescriptionBoxHeight(descriptionBoxRef.current.offsetHeight);
    }
    if (
      copyBoxRef.current &&
      copyBoxRef.current.offsetHeight !== copyBoxHeight
    ) {
      setCopyBoxHeight(copyBoxRef.current.offsetHeight);
    }
  }, [windowWidth]);

  const [anchorElMeeting, setAnchorElMeeting] = useState(null);
  const handleClick = (event) => {
    setAnchorElMeeting(event.currentTarget);
  };
  const handleCloseMeeting = () => {
    setAnchorElMeeting(null);
  };
  const [showSchedule, setShowSchedule] = useState(false);
  const padding = useResponsiveSize({
    xl: 6,
    lg: 6,
    md: 6,
    sm: 4,
    xs: 1.5,
  });
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "black",
    border: "0px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
  };

  return (
    <Box
      // mt={3}
      style={{
        // maxHeight: boxHeight,
        width: "100%",
        display: "flex",
        flex: 1,
        flexDirection: "column",
        // backgroundColor: "pink",
      }}
    >
      <Modal
        open={showSchedule}
        onClose={() => {
          setShowSchedule(!showSchedule);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            container
            spacing={padding}
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              // backgroundColor: "purple",
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{
                width: "100%",
                display: "flex",
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",

                // backgroundColor: "pink",
              }}
            >
              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box mt={0} style={{ width: "100%" }}>
                  <DateTimePicker
                    autoOk
                    variant="static"
                    style={{ width: "100%" }}
                    value={selectedDate}
                    onChange={handleDateChange}
                  />
                </Box>
              </Box>

              <Button
                style={{ marginTop: 10, width: "100%" }}
                variant="contained"
                onClick={async () => {

                  const data = await axios.get(
                    `https://www.addevent.com/api/v1/me/calendars/create/?token=api16316061060xuGHFehQJropScCqV6B132094&title=${name}&description=noweventsmeeting`
                  );

                  const addCalendar = await axios.get(
                    `https://www.addevent.com/api/v1/me/calendars/events/create/?token=api16316061060xuGHFehQJropScCqV6B132094&calendar_id=${data?.data?.calendar?.id}&title=${name}&description=noweventsmeeting&location=Singapore&organizer=nowevents&organizer_email=${user?.email}reminder=60&start_date=${selectedDate}&end_date=${selectedDate}&all_day_event=false&custom_data=null`
                  );

                  await axios.get(
                    `https://www.addevent.com/api/v1/me/calendars/events/save/?token=api16316061060xuGHFehQJropScCqV6B132094&event_id=${addCalendar?.data?.event?.id}&title=${name}&description=noweventsmeeting&location=Singapore&organizer=nowevents&organizer_email=${user?.email}reminder=60&start_date=${selectedDate}&end_date=${selectedDate}&all_day_event=false&custom_data=null`
                  );

                  startMeeting(selectedDate,"SET");
                  setShowSchedule(false)
                }}
                // onClick={add}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {(meetingUrl && meetingTitle) || meetingUrl ? (
        <Card
          style={{
            borderRadius: 10,
            color: theme.palette.primary.contrastText,
          }}
        >
          <Box p={internalPadding}>
            {meetingTitle ? (
              <div
                style={{
                  fontFamily: "Inter,Arial,sans-serif",
                  color: theme.palette.primary.contrastText,
                }}
              >
                <LinesEllipsis
                  text={meetingTitle}
                  maxLine="3"
                  ellipsis="..."
                  style={{
                    width: "100%",
                    fontSize: "20px",
                    fontWeight: "bold",

                    fontFamily: "inherit",
                  }}
                />
              </div>
            ) : null}

            {meetingUrl ? (
              <Box
                ref={copyBoxRef}
                mt={meetingTitle ? 2 : 0}
                p={2.5}
                pt={1}
                pb={1}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                  backgroundColor: "#1C1F2E80",
                  borderRadius: 4,
                  overflow: "hidden",
                  alignItems: "center",
                }}
              >
                <Box
                  style={{
                    overflow: "hidden",
                    display: "flex",
                    flex: 1,
                  }}
                >
                  <Typography
                    style={{
                      width: "100%",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                    variant="subtitle1"
                  >
                    {meetingUrl}
                  </Typography>
                </Box>
                <Box
                  style={{
                    // backgroundColor: theme.palette.primary.main,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  //   onClick={(e) => {
                  //     setCopied(e);
                  //   }}
                >
                  <Tooltip title={copied ? "Copied" : "Copy"} aria-label="add">
                    <IconButton
                      style={{
                        padding: 0,
                        margin: 0,
                      }}
                      onClick={(e) => {
                        setCopied(e);
                      }}
                    >
                      <CopyIcon
                        fill={"#fff"}
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {/* <IconButton
                      style={{
                        padding: 0,
                        margin: 15,
                      }}
                      onClick={(e) => {
                        setCopied(e);
                      }}
                    >
                      <CopyIcon
                        fill={"#fff"}
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    </IconButton> */}
                </Box>
              </Box>
            ) : null}
          </Box>
        </Card>
      ) : meetingTitle ? (
        <div
          style={{
            fontFamily: "Inter,Arial,sans-serif",
            color: theme.palette.primary.contrastText,
          }}
        >
          <LinesEllipsis
            text={"Create Meeting"}
            maxLine="3"
            ellipsis="..."
            style={{
              width: "100%",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          />
        </div>
      ) : null}

      <Box mt={meetingTitle || meetingUrl ? 2 : 0} style={{ width: "100%" }}>
        <TextField
          id={"inputJoin"}
          placeholder={
            type === "participant" ? "Enter meeting id" : "Enter meeting name"
          }
          // helperText="Your name will help everyone identify you in the meeting"
          variant="outlined"
          fullWidth
          value={name}
          error={nameErr}
          // helperText={
          //   nameErr
          //     ? "Enter Minimum 3 Characterrs"
          //     : "Your name will help everyone identify you in the meeting"
          // }
          onChange={(ev) => {
            setName(ev.target.value);
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "row",
            marginTop: 10,
          }}
        >
          <Button
            //   disabled={name.length <= 3}
            color="primary"
            style={{ width: "45%" }}
            variant="contained"
            //   onClick={startMeeting}
            onClick={(e) => {
              const isValid = handleValidation();
              if (isValid) {
                setShowSchedule(!showSchedule);
              } else {
                toast.error("Please enter meeting name");
              }

              // const isValid = handleValidation();
              // if (isValid) {
              //   startMeeting(selectedDate);
              // } else {
              //   toast.error("Please enter meeting name");
              // }
            }}
            id={"btnJoin"}
          >
            Schedule
          </Button>
          <Button
            style={{ width: "45%" }}
            //   disabled={name.length <= 3}
            color="primary"
            variant="contained"
            //   onClick={startMeeting}
            onClick={(e) => {
              const isValid = handleValidation();
              if (isValid) {
                startMeeting(selectedDate);
              } else {
                toast.error("Please enter meeting name");
              }
            }}
            id={"btnJoin"}
          >
            Meet Now
          </Button>
        </div>
      </Box>
    </Box>
  );
}

// InputProps={{
//   startAdornment:
//     type === "participant" ? null : (
//       <InputAdornment
//         // onCreateMeeting
//         style={{ width: "50%" }}
//         position="start"
//       >
//         <DateTimePicker
//           value={selectedDate}
//           onChange={handleDateChange}
//         />
//       </InputAdornment>
//     ),
//   endAdornment: (
//     <InputAdornment position="end">
//       <Button
//         //   disabled={name.length <= 3}
//         color="primary"
//         variant="contained"
//         //   onClick={startMeeting}
//         onClick={(e) => {
//           const isValid = handleValidation();
//           if (isValid) {
//             startMeeting(selectedDate);
//           } else {
//             toast.error("Please enter meeting name");
//           }
//         }}
//         id={"btnJoin"}
//       >
//         Join
//       </Button>
//     </InputAdornment>
//   ),
// }}
